import React, { useState } from "react";
import style from "./style.module.css";

const data = [
  {
    feedback:
      "En termes de visibilité,Agenz est le partenaire digital indispensable pour toucher les vendeurs particuliers.",
    author: "Meryam | CityWalls,Casablanca",
  },
  {
    feedback:
      "Une plateforme sérieuse,avec des acteurs sérieux,que ce soit les clients ou les agences immobiliéres partenaires.",
    author: "Nabila | Clavis immobilier,Casablanca",
  },
  {
    feedback:
      "Plus de 70% de nos biens à vendre viennent des projets detectés agenz Notre agence est devenue plus efficace car nous restons focalisés sur notre métier de trouver les bons profils acheteurs pour ces biens proposés à la vente. un grand merci à toute l’équipe.",
    author: "Adil Chaâbi | Gérant,Asset Services",
  },
  {
    feedback:
      "J’utilise agenz depuis quelques mois,principalement pour la valeur ajoutée apportée dans la mise en relation des propriétaires avec les professionnels . L’outil est excellent pour la génération de leads qualifiés. Félicitations à l’équipe trés professionnelle et à l’écoute.",
    author: "Mohammed Benjelloun | Gérant, Alter Foncier",
  },
];

function Feadback(props) {
  const [index, setIndex] = useState(0);

  const handlePrev = () => {
    if (index > 0) setIndex(index - 1);
  };

  const handleNext = () => {
    if (index < props.feadback?.length - 1) setIndex(index + 1);
  };

  return (
    <div className={style.container}>
      <div onClick={handlePrev}>
        <svg
          width="22"
          height="40"
          viewBox="0 0 22 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9 38.8375C21.1519 38.5805 21.293 38.2349 21.293 37.875C21.293 37.5151 21.1519 37.1695 20.9 36.9125L4.12498 20L20.9 3.08749C21.1519 2.83047 21.293 2.4849 21.293 2.12499C21.293 1.76508 21.1519 1.41952 20.9 1.16249C20.6429 0.910556 20.2974 0.76944 19.9375 0.76944C19.5776 0.76944 19.232 0.910556 18.975 1.16249L1.09998 19.0375C0.848038 19.2945 0.706923 19.6401 0.706923 20C0.706923 20.3599 0.848038 20.7055 1.09998 20.9625L18.975 38.8375C19.232 39.0894 19.5776 39.2305 19.9375 39.2305C20.2974 39.2305 20.6429 39.0894 20.9 38.8375Z"
            fill="black"
            fillOpacity="0.24"
          />
        </svg>
      </div>
      <div className={style.content}>
        {props.feadback?.map((item, key) => {
          return (
            <div
              key={key}
              className={style.feedbackElement}
              style={{
                display: index === key ? "flex" : "none",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <p className={style.feedback}>
                <svg
                  style={{ marginRight: "10px", marginBottom: "5px" }}
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 8V12.25C12.5 12.9501 12.5 13.2999 12.6362 13.5672C12.7561 13.8025 12.9472 13.9941 13.1824 14.1139C13.4495 14.25 13.7994 14.25 14.4981 14.25H16.7519C17.4506 14.25 17.8 14.25 18.0671 14.1139C18.3023 13.9941 18.494 13.8023 18.6139 13.5671C18.75 13.3 18.75 12.9506 18.75 12.2519V9.99807C18.75 9.29937 18.75 8.9495 18.6139 8.68237C18.4941 8.44717 18.3024 8.25608 18.0672 8.13624C17.7999 8 17.4501 8 16.75 8H12.5Z"
                    fill="#00B4FF"
                  />
                  <path
                    d="M1.25 8V12.25C1.25 12.9501 1.25 13.2999 1.38624 13.5672C1.50608 13.8025 1.69717 13.9941 1.93237 14.1139C2.1995 14.25 2.54937 14.25 3.24807 14.25H5.50193C6.20063 14.25 6.54999 14.25 6.81712 14.1139C7.05232 13.9941 7.24405 13.8023 7.36389 13.5671C7.5 13.3 7.5 12.9506 7.5 12.2519V9.99808C7.5 9.29938 7.5 8.9495 7.36389 8.68237C7.24405 8.44717 7.05245 8.25608 6.81724 8.13624C6.54985 8 6.20007 8 5.5 8H1.25Z"
                    fill="#00B4FF"
                  />
                  <path
                    d="M12.5 8V12.25C12.5 12.9501 12.5 13.2999 12.6362 13.5672C12.7561 13.8025 12.9472 13.9941 13.1824 14.1139C13.4495 14.25 13.7994 14.25 14.4981 14.25H16.7519C17.4506 14.25 17.8 14.25 18.0671 14.1139C18.3023 13.9941 18.494 13.8023 18.6139 13.5671C18.75 13.3 18.75 12.9506 18.75 12.2519V9.99807C18.75 9.29937 18.75 8.9495 18.6139 8.68237C18.4941 8.44717 18.3024 8.25608 18.0672 8.13624C17.7999 8 17.4501 8 16.75 8H12.5ZM12.5 8V5.5C12.5 3.42893 14.1789 1.75 16.25 1.75M1.25 8V12.25C1.25 12.9501 1.25 13.2999 1.38624 13.5672C1.50608 13.8025 1.69717 13.9941 1.93237 14.1139C2.1995 14.25 2.54937 14.25 3.24807 14.25H5.50193C6.20063 14.25 6.54999 14.25 6.81712 14.1139C7.05232 13.9941 7.24405 13.8023 7.36389 13.5671C7.5 13.3 7.5 12.9506 7.5 12.2519V9.99808C7.5 9.29938 7.5 8.9495 7.36389 8.68237C7.24405 8.44717 7.05245 8.25608 6.81724 8.13624C6.54985 8 6.20007 8 5.5 8H1.25ZM1.25 8V5.5C1.25 3.42893 2.92893 1.75 5 1.75"
                    stroke="#00B4FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {item.feadback[props.lang]}
                <svg
                  style={{ marginLeft: "10px", marginTop: "0px" }}
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 8V12.25C7.5 12.9501 7.5 13.2999 7.36376 13.5672C7.24392 13.8025 7.05283 13.9941 6.81763 14.1139C6.5505 14.25 6.20063 14.25 5.50193 14.25H3.24807C2.54937 14.25 2.20001 14.25 1.93288 14.1139C1.69768 13.9941 1.50595 13.8023 1.38611 13.5671C1.25 13.3 1.25 12.9506 1.25 12.2519V9.99807C1.25 9.29937 1.25 8.9495 1.38611 8.68237C1.50595 8.44717 1.69756 8.25608 1.93276 8.13624C2.20015 8 2.54993 8 3.25 8H7.5Z"
                    fill="#00B4FF"
                  />
                  <path
                    d="M18.75 8V12.25C18.75 12.9501 18.75 13.2999 18.6138 13.5672C18.4939 13.8025 18.3028 13.9941 18.0676 14.1139C17.8005 14.25 17.4506 14.25 16.7519 14.25H14.4981C13.7994 14.25 13.45 14.25 13.1829 14.1139C12.9477 13.9941 12.7559 13.8023 12.6361 13.5671C12.5 13.3 12.5 12.9506 12.5 12.2519V9.99808C12.5 9.29938 12.5 8.9495 12.6361 8.68237C12.7559 8.44717 12.9476 8.25608 13.1828 8.13624C13.4501 8 13.7999 8 14.5 8H18.75Z"
                    fill="#00B4FF"
                  />
                  <path
                    d="M7.5 8V12.25C7.5 12.9501 7.5 13.2999 7.36376 13.5672C7.24392 13.8025 7.05283 13.9941 6.81763 14.1139C6.5505 14.25 6.20063 14.25 5.50193 14.25H3.24807C2.54937 14.25 2.20001 14.25 1.93288 14.1139C1.69768 13.9941 1.50595 13.8023 1.38611 13.5671C1.25 13.3 1.25 12.9506 1.25 12.2519V9.99807C1.25 9.29937 1.25 8.9495 1.38611 8.68237C1.50595 8.44717 1.69755 8.25608 1.93276 8.13624C2.20015 8 2.54993 8 3.25 8H7.5ZM7.5 8V5.5C7.5 3.42893 5.82107 1.75 3.75 1.75M18.75 8V12.25C18.75 12.9501 18.75 13.2999 18.6138 13.5672C18.4939 13.8025 18.3028 13.9941 18.0676 14.1139C17.8005 14.25 17.4506 14.25 16.7519 14.25H14.4981C13.7994 14.25 13.45 14.25 13.1829 14.1139C12.9477 13.9941 12.756 13.8023 12.6361 13.5671C12.5 13.3 12.5 12.9506 12.5 12.2519V9.99808C12.5 9.29938 12.5 8.9495 12.6361 8.68237C12.756 8.44717 12.9476 8.25608 13.1828 8.13624C13.4501 8 13.7999 8 14.5 8H18.75ZM18.75 8V5.5C18.75 3.42893 17.0711 1.75 15 1.75"
                    stroke="#00B4FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </p>
              <p className={style.author}>{item.author[props.lang]}</p>
            </div>
          );
        })}
        <div className={style.dots}>
          {[...Array(props.feadback?.length)].map((item, key) => {
            return (
              <div
                key={key}
                className={`${style.dot} ${key === index ? style.bgOne : ""}`}
              ></div>
            );
          })}
        </div>
      </div>
      <div onClick={handleNext}>
        <svg
          width="22"
          height="40"
          viewBox="0 0 22 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.09999 38.8375C0.848056 38.5805 0.70694 38.2349 0.70694 37.875C0.70694 37.5151 0.848056 37.1695 1.09999 36.9125L17.875 20L1.09999 3.08749C0.848056 2.83047 0.70694 2.4849 0.70694 2.12499C0.70694 1.76508 0.848056 1.41952 1.09999 1.16249C1.35702 0.910556 1.70258 0.76944 2.06249 0.76944C2.4224 0.76944 2.76797 0.910556 3.02499 1.16249L20.9 19.0375C21.1519 19.2945 21.293 19.6401 21.293 20C21.293 20.3599 21.1519 20.7055 20.9 20.9625L3.02499 38.8375C2.76797 39.0894 2.4224 39.2305 2.06249 39.2305C1.70258 39.2305 1.35702 39.0894 1.09999 38.8375Z"
            fill="black"
            fillOpacity="0.24"
          />
        </svg>
      </div>
    </div>
  );
}

export default Feadback;
